let TeamsCombinations = {
    SET_EXPOSURE_MAX_OF_TEAM_COMBINATIONS: 'SET_EXPOSURE_MAX_OF_TEAM_COMBINATIONS',
    // UNSET_EXPOSURE_OF_TEAM_COMBINATIONS: 'UNSET_EXPOSURE_OF_TEAM_COMBINATIONS',
};

export default TeamsCombinations;
